import { render, staticRenderFns } from "./v-navigation-cards.vue?vue&type=template&id=8e647114&scoped=true&"
import script from "./v-navigation-cards.vue?vue&type=script&lang=js&"
export * from "./v-navigation-cards.vue?vue&type=script&lang=js&"
import style0 from "./v-navigation-cards.vue?vue&type=style&index=0&id=8e647114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e647114",
  null
  
)

export default component.exports